import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StoryState } from "./story.state";
import { HomeStory } from "../home/home.types";

const initialState: StoryState = {
  isOpen: false,
  currentStoryIndex: -1,
  currentItemIndex: 0,
  isPlaying: false,
  isPaused: false,
  progress: 0,
  stories: [],
};

const storySlice = createSlice({
  name: "story",
  initialState,
  reducers: {
    setStories: (state, action: PayloadAction<HomeStory[]>) => {
      state.stories = action.payload;
    },
    openStory: (state, action: PayloadAction<number>) => {
      state.isOpen = true;
      state.currentStoryIndex = action.payload;
      state.currentItemIndex = 0;
      state.isPlaying = true;
      state.isPaused = false;
      state.progress = 0;
    },
    closeStory: (state) => {
      state.isOpen = false;
      state.isPlaying = false;
      state.isPaused = false;
      state.progress = 0;
      state.currentStoryIndex = -1;
      state.currentItemIndex = 0;
    },
    nextItem: (state) => {
      const currentStory = state.stories[state.currentStoryIndex];
      if (
        currentStory &&
        state.currentItemIndex < currentStory.items.length - 1
      ) {
        state.currentItemIndex += 1;
        state.progress = 0;
      }
    },
    prevItem: (state) => {
      if (state.currentItemIndex > 0) {
        state.currentItemIndex -= 1;
        state.progress = 0;
      }
    },
    nextStory: (state) => {
      if (state.currentStoryIndex < state.stories.length - 1) {
        state.currentStoryIndex += 1;
        state.currentItemIndex = 0;
        state.progress = 0;
      }
    },
    prevStory: (state) => {
      if (state.currentStoryIndex > 0) {
        state.currentStoryIndex -= 1;
        const prevStory = state.stories[state.currentStoryIndex];
        state.currentItemIndex = prevStory ? prevStory.items.length - 1 : 0;
        state.progress = 0;
      }
    },
    setProgress: (state, action: PayloadAction<number>) => {
      state.progress = Math.min(100, Math.max(0, action.payload));
    },
    resetProgress: (state) => {
      state.progress = 0;
    },
    pauseStory: (state) => {
      if (state.isPlaying) {
        state.isPlaying = false;
        state.isPaused = true;
      }
    },
    resumeStory: (state) => {
      if (state.isPaused) {
        state.isPlaying = true;
        state.isPaused = false;
      }
    },
  },
});

export const {
  setStories,
  openStory,
  closeStory,
  nextItem,
  prevItem,
  nextStory,
  prevStory,
  setProgress,
  resetProgress,
  pauseStory,
  resumeStory,
} = storySlice.actions;

export default storySlice.reducer;
